import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/gameDesign'

export default function gameDesign() {
  return <ProjectLayout data={data} />
}
